// extracted by mini-css-extract-plugin
export var quillEditor = "_mi-1";
export var variable = "_mi-0";